import { observable, computed, action, makeObservable } from "mobx";
import { getMeds } from "../../serviceCalls";

export default class MedsStore {
  meds = [];
  selectedFilterOption;
  searchText;
  loading;
  err;

  constructor() {
    makeObservable(this, {
      meds: observable,
      selectedFilterOption: observable,
      searchText: observable,
      loading: observable,
      err: observable,
      filteredMeds: computed,
      fetchMeds: action,
    });
  }

  get filteredMeds() {
    return (
      this.selectedFilterOption.value === "All"
        ? this.meds.filter((med) => med.type !== "Suspended")
        : this.meds.filter(
            (med) => med.type === this.selectedFilterOption.value,
          )
    ).filter(
      (med) =>
        !this.searchText ||
        med.name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
        med.clinicalDisplay
          .toLowerCase()
          .indexOf(this.searchText.toLowerCase()) !== -1,
    );
  }

  fetchMeds(asmpid) {
    this.loading = true;
    return getMeds(asmpid)
      .then((res) => {
        this.meds = res.medications;
        return res;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
